module.exports = __webpack_public_path__ + "static/media/bbc-iplayer-web.8709a029.jpg";